import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import {
    Portlet,
    PortletBody,
    PortletHeader,
    PortletHeaderToolbar
} from '../../../partials/content/Portlet';
import { store } from 'react-notifications-component';
import * as Yup from 'yup'; // for everything
import { Formik } from 'formik';
import { Container, Row, Col, Card, Badge, Button, Modal, Dropdown, Table, Form } from 'react-bootstrap';
import { LeaseTerminationsServices } from '../LeaseTerminations/LeaseTerminations.services'
import { formatDate, formatDateTime, formatAmount } from '../../../../_metronic/utils/utils';
import * as constants from '../../../constants';
import FilterComponent from '../../../partials/layout/FilterComponent';
import * as firebase from 'firebase/app';
import UltimatePagination from '../../../partials/layout/PaginationComponent';
import { commonServices } from '../../../commonServices/commonServices';
import { debounce } from 'throttle-debounce';
import { RerentingTrackerServices } from './RerentingTracker.services';
// import moment from 'moment';

class ReRentingTracker extends Component {

    constructor(props) {
        super(props);
        this.state = {
            ...props,
            totalCount: undefined,
            isFetching: false,
            page: 1,
            total: undefined,
            offset: 0,
            limit: 10,
            showConfirmModal: false,
            confirmAction: null,
            confirmMessage: "",
            showLeaseExtensionModal: false,
            showInitiateMoveOutModal: false,
            requestedFilters: [
                'propertyManagementStatus', 'state'
            ],
            propertyManagementStatus: []
        }
    }

    isNullStatus = (status) => status === null || status === "null" || status === "NULL";

    async componentDidMount() {
        await this.getLeasesList();
        await this.getCities();
        await this.getPropertyManagersMoveinManagerAndSalesManager();
    }

    /**
     * Method to get property managers
     */
    getPropertyManagersMoveinManagerAndSalesManager = async () => {
        const data = {
            userRoleCodes: ['PROPERTY_MANAGER', 'SALES_MANAGER', 'MOVE_IN_MANAGER'],
        }
        const result = await commonServices.getUserListData(data);
        if (result && result.status === 200) {
            const propertyManagers = result.data.users.filter(user =>
                user.userRoleCodes?.includes("PROPERTY_MANAGER")
            );
            const salesManagers = result.data.users.filter(user =>
                user.userRoleCodes?.includes("SALES_MANAGER")
            );
            const moveInManagers = result.data.users.filter(user =>
                user.userRoleCodes?.includes("MOVE_IN_MANAGER")
            );
            await this.setState({ propertyManagers: propertyManagers, salesManagers: salesManagers, moveInManagers: moveInManagers })
        }
    }

    /**
 * Method to get all the cities
 */
    getCities = async () => {
        const { cityIds } = this.state;
        const data = {
            pmsOperationStatus: 'YES'
        }
        const result = await commonServices.getCities(data);
        if (result && result.status === 200) {
            const cities = result?.data?.cities;
            const formattedCities = commonServices.formatCities(cities);
            let preSelectedCities = null;
            if (this.state.cityIds?.length > 0) {
                preSelectedCities = commonServices.preSelectCities(formattedCities, cityIds);
            }
            this.setState({ formattedCities });
            preSelectedCities && this.setState({ preSelectedCities });
        }
    }
    /**
   * component will mount method
   */
    componentWillMount() {
        this.getLeasesList = debounce(
            800,
            this.getLeasesList
        )
    }

    getLeasesList = async () => {
        this.setState({ isFetching: true });
        const { offset, state, limit, propertyManagerId, propertyManagementStatus, minimumExpectedMoveOutDate, maximumExpectedMoveOutDate, cityIds, salesManagerId, reRentingStatus, isNewbeatsNull, reRentingAvailabilityStatus, reRentingRemarksCategory, moveInManagerId } = this.state;
        const data = {
            reRentingRemarksCategory,
            reRentingStatus,
            isNewbeatsNull,
            reRentingAvailabilityStatus,
            salesManagerId: salesManagerId !== '0' ? salesManagerId : undefined,
            cityIds,
            propertyManagementStatus: (propertyManagementStatus && propertyManagementStatus[0]) || undefined,
            moveInManagerId: moveInManagerId !== '0' ? moveInManagerId : undefined,
            minimumExpectedMoveOutDate,
            maximumExpectedMoveOutDate,
            propertyManagerId: propertyManagerId !== '0' ? propertyManagerId : undefined,
            state: (state && state[0]) || undefined,
            moveOutState: 'OPEN',
            offset,
            limit,
            include: ['HOUSE', 'PROPERTY_MANAGER', 'CURRENT_RENT', 'SALES_MANAGER']
        }

        const result = await LeaseTerminationsServices.getLeasesList(data);
        if (result && result.status === 200) {
            const totalCount = result.headers['x-total-count'];
            const totalPageNo = Math.ceil(totalCount / limit)
            await this.setState({
                leases: result.data.leases,
                total: totalPageNo === 0 ? 1 : totalPageNo,
                totalCount
            });
        }

        this.setState({ isFetching: false });
    }

    onPageChange = async (page) => {
        const { limit } = this.state;
        const offset = (limit * (page - 1));
        await this.setState({ page, offset });
        await this.getLeasesList();
    }

    /**
     * Method to handle data of add payment component
   * @param {String} childData
   */
    handleFilterChildData = async (childData) => {
        if (childData) {
            this.setState({ ...childData })
            await this.resetPage();
            await this.getLeasesList();
            await this.getCities();
            await this.getPropertyManagersMoveinManagerAndSalesManager();
            firebase.analytics().logEvent("apply_filter_button_click", { description: "Apply Filter Button Clicked", filterComponent: 'On Going Move-outs' });
        }
    }

    /**
  * Method to reset Pagination
  */
    resetPage = async () => {
        await this.setState({
            page: 1,
            offset: 0,
            // limit: 10,
        })
    }
    getLeaseMoveOutStatusBadge = (status) => {
        if (status === 'YES') return <Badge variant="danger" title="Move-Out">C</Badge>
        else return <Badge variant="success" title="Move-Out In Process">O</Badge>
    }


    render() {
        const {
            leases, page, total, totalCount, isFetching, propertyManagementStatus, minimumExpectedMoveOutDate, maximumExpectedMoveOutDate, propertyManagers, formattedCities, preSelectedCities, propertyManagerId,
            requestedFilters, salesManagers, moveInManagers, moveInManagerId
        } = this.state;
        let showPagination = false;
        if (total) { showPagination = total !== 0 && total !== 1; }
        let taskAssigneeData = [];
        taskAssigneeData.push(this.props.userDetails)
        if (isFetching) {
            return <p>Loading data...</p>
        }
        return (
            <>
                <Container fluid>
                    <Portlet fluidHeight={true}>
                        <PortletHeader
                            title={`Rerental Inventories (${totalCount || 0})`}
                            toolbar={
                                <PortletHeaderToolbar>
                                </PortletHeaderToolbar>
                            }
                        />
                        <PortletBody >
                            <FilterComponent
                                moveInManagers={moveInManagers}
                                moveInManagerId={moveInManagerId}
                                formattedCities={formattedCities}
                                preSelectedCities={preSelectedCities}
                                requestedFilters={requestedFilters}
                                propertyManagers={propertyManagers}
                                salesManagers={salesManagers}
                                propertyManagerId={propertyManagerId}
                                minimumExpectedMoveOutDate={minimumExpectedMoveOutDate}
                                maximumExpectedMoveOutDate={maximumExpectedMoveOutDate}
                                recordsPerPage={constants.RECORDS_PER_PAGE}
                                selectedRecordValue={this.state.limit}
                                state={this.state.state}
                                selectedRerentStatus={this.state.reRentingStatus}
                                selectedNewBeatsListingId={this.state.isNewbeatsNull}
                                // selectedRerentAvailabilityStatus={this.state.reRentingAvailabilityStatus}
                                filterParentCallback={this.handleFilterChildData}
                                propertyManagementStatus={propertyManagementStatus}
                            />
                            <Card>
                                {leases && leases.length === 0 && <p>{constants.ZERO_DATA}</p>}

                                {leases && leases.length > 0 && (
                                    <Card.Body className="p-0">
                                        <Table striped bordered hover responsive>
                                            <thead className="bg-light">
                                                <tr>
                                                    <th>Property</th>
                                                    <th>Beats Listing ID</th>
                                                    <th>Current Rent & Deposit</th>
                                                    <th>Move-In Date</th>
                                                    <th>Move-out Initiation Date</th>
                                                    <th>Expected & Actual Move-out Date</th>
                                                    <th>Rerenting Status</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {leases.map((lease) => (
                                                    <tr key={"lease" + lease.id}>
                                                        <td>
                                                            <span className="pr-3">
                                                                {this.getLeaseMoveOutStatusBadge(lease.moveOutTerminalStatus)}
                                                            </span>
                                                            <Link to={`/property-profile/${lease.house.id}`}>
                                                                <span>{lease.house.formattedHouseName}</span>
                                                            </Link>
                                                            <br />
                                                            <span className="small text-muted pl-5">
                                                                {lease.propertyManager?.fullName
                                                                    ? `PM: ${lease.propertyManager.fullName}`
                                                                    : `PM: Not Assigned`}
                                                            </span>
                                                            <br />
                                                            {lease.salesManager ? (
                                                                <span className="small text-muted pl-5">
                                                                    SM: {lease.salesManager.fullName}
                                                                </span>
                                                            ) : (
                                                                <span className="small text-warning pl-5">
                                                                    SM: Not Assigned
                                                                </span>
                                                            )}
                                                        </td>

                                                        <td>
                                                            {/* <span className="text-success">
                                                                {lease.houseOffering.beatsListingIdentifier ? lease.houseOffering.beatsListingIdentifier : "Not found"}
                                                            </span>
                                                            <br /> */}
                                                            {lease.houseOffering.newbeatsListingIdentifier ? (
                                                                <span className="text-success">
                                                                    {lease.houseOffering.newbeatsListingIdentifier}
                                                                </span>
                                                            ) : (
                                                                <Button variant="outline-primary"
                                                                    size="sm"
                                                                    className="py-0 px-2 mt-2"
                                                                    style={{ fontSize: "12px", lineHeight: "1.2" }}
                                                                    disabled={
                                                                        !(
                                                                            this.props.userDetails.userRoleCodes.includes('SALES_MANAGER') ||
                                                                            this.props.userDetails.userRoleCodes.includes('PROPERTY_MANAGEMENT_HEAD')
                                                                        )
                                                                    } onClick={() =>
                                                                        this.setState({
                                                                            showAddBeatsModal: true,
                                                                            selectedLease: lease,
                                                                        })
                                                                    }
                                                                >
                                                                    + New ID
                                                                </Button>
                                                            )}
                                                        </td>

                                                        <td>
                                                            <span className="text-success fw-bold">
                                                                {lease.currentRent ? formatAmount(lease.currentRent) : "Not found"}
                                                            </span>
                                                            <br />
                                                            <span className="text-primary fw-bold">
                                                                {lease.securityDeposit
                                                                    ? formatAmount(lease.securityDeposit)
                                                                    : "Not found"}
                                                            </span>
                                                        </td>

                                                        <td style={{ minWidth: "150px" }}>
                                                            <span className="text-primary fw-semibold">
                                                                {lease.moveInDate ? formatDate(lease.moveInDate) : "Not found"}
                                                            </span>
                                                        </td>

                                                        <td>
                                                            <span >
                                                                {lease.moveOutInitiationStatusMarkedAt
                                                                    ? formatDate(lease.moveOutInitiationStatusMarkedAt)
                                                                    : "Not found"}
                                                            </span>
                                                        </td>

                                                        <td>
                                                            <span className="text-success">
                                                                {lease.expectedMoveOutDate ? formatDate(lease.expectedMoveOutDate) : "Not found"}
                                                            </span>
                                                            <br />
                                                            <span className="text-danger">
                                                                {lease.moveOutDate ? formatDate(lease.moveOutDate) : "Not found"}
                                                            </span>
                                                        </td>
                                                        <td>
                                                            <Col md={2} className="px-3 py-2 text-end text-nowrap align-middle">
                                                                {(this.isNullStatus(lease.reRentingStatus) || lease.reRentingStatus === "HOLD") && (
                                                                    <Dropdown>
                                                                        <Dropdown.Toggle
                                                                            variant="outline-secondary"
                                                                            size="sm"
                                                                            disabled={!this.props.userDetails.userRoleCodes.includes('PROPERTY_MANAGEMENT_HEAD')}
                                                                        >
                                                                            {this.isNullStatus(lease.reRentingStatus) ? "Available" : "Edit Hold Status"}
                                                                        </Dropdown.Toggle>

                                                                        <Dropdown.Menu>

                                                                            {lease.reRentingStatus === "HOLD" && (<Dropdown.Item
                                                                                onClick={() =>
                                                                                    this.setState({
                                                                                        showConfirmModal: true,
                                                                                        confirmMessage: "Are you sure you want to mark this property as Available?",
                                                                                        confirmAction: async () =>
                                                                                            await RerentingTrackerServices.markRerentingStatus(lease.id, { reRentingStatus: "NULL" })
                                                                                    })
                                                                                }

                                                                            >
                                                                                Mark as Available
                                                                            </Dropdown.Item>)}

                                                                            <Dropdown.Item
                                                                                onClick={() =>
                                                                                    this.setState({ selectedLease: lease, showLostModal: true, lostOrHold: "LOST" })
                                                                                }
                                                                            >
                                                                                Mark as Lost
                                                                            </Dropdown.Item>

                                                                            <Dropdown.Item
                                                                                onClick={() =>
                                                                                    this.setState({ selectedLease: lease, showRerentedModal: true })
                                                                                }
                                                                            >
                                                                                Mark as Rerented
                                                                            </Dropdown.Item>

                                                                            <Dropdown.Item
                                                                                onClick={() =>
                                                                                    this.setState({ selectedLease: lease, showLostModal: true, lostOrHold: "HOLD" })
                                                                                }
                                                                            >
                                                                                Mark as Hold
                                                                            </Dropdown.Item>

                                                                            <Dropdown.Item
                                                                                onClick={() =>
                                                                                    this.setState({ selectedLease: lease, showLostModal: true, lostOrHold: "RERENTED_NOT_MERGED" })
                                                                                }
                                                                            >
                                                                                Mark as Rerented Not Merged
                                                                            </Dropdown.Item>
                                                                        </Dropdown.Menu>
                                                                    </Dropdown>
                                                                )}
                                                                {lease.reRentingStatus === "RERENTED_NOT_MERGED" && (
                                                                    <Dropdown>
                                                                        <Dropdown.Toggle
                                                                            variant="outline-secondary"
                                                                            size="sm"
                                                                            disabled={!this.props.userDetails.userRoleCodes.includes('PROPERTY_MANAGEMENT_HEAD')}
                                                                        >
                                                                            Edit Rerented Not Merged Status
                                                                        </Dropdown.Toggle>

                                                                        <Dropdown.Menu>
                                                                            <Dropdown.Item
                                                                                onClick={() =>
                                                                                    this.setState({ selectedLease: lease, showRerentedModal: true })
                                                                                }
                                                                            >
                                                                                Mark as Rerented
                                                                            </Dropdown.Item>
                                                                        </Dropdown.Menu>
                                                                    </Dropdown>
                                                                )}
                                                                {lease.reRentingStatus === "LOST" && (
                                                                    <Button
                                                                        variant="outline-danger"
                                                                        size="sm"
                                                                        onClick={() =>
                                                                            this.setState({
                                                                                selectedLease: lease,
                                                                                showViewReasonModal: true,
                                                                                lostOrHold: "LOST"
                                                                            })
                                                                        }
                                                                    >
                                                                        View Lost Reason
                                                                    </Button>
                                                                )}
                                                                {lease.reRentingStatus === "RERENTED" && (
                                                                    <span className="fw-bold text-success">
                                                                        {lease.reRentingStatus}
                                                                    </span>
                                                                )}
                                                            </Col>


                                                        </td>


                                                    </tr>
                                                ))}
                                            </tbody>
                                        </Table>
                                    </Card.Body>
                                )}
                            </Card>

                            <Modal
                                show={this.state.showLostModal}
                                onHide={() => this.setState({ showLostModal: false })}
                                centered
                            >
                                <Modal.Header closeButton>
                                    <Modal.Title>
                                        {
                                            this.state.lostOrHold === "LOST"
                                                ? "Lost Status Remarks"
                                                : this.state.lostOrHold === "HOLD"
                                                    ? "Hold Remarks"
                                                    : "Rerented Not Merged Remarks"
                                        }
                                    </Modal.Title>
                                </Modal.Header>

                                <Modal.Body>
                                    <Formik
                                        initialValues={{
                                            reRentingRemarksCategory: "",
                                            reRentingRemarks: ""
                                        }}
                                        validate={(values) => {
                                            const errors = {};
                                            if (this.state.lostOrHold === "LOST" && !values.reRentingRemarksCategory) {
                                                errors.reRentingRemarksCategory = "Please select a category";
                                            }

                                            if (!values.reRentingRemarks || values.reRentingRemarks.trim() === "") {
                                                errors.reRentingRemarks = "Remarks are required";
                                            }

                                            return errors;
                                        }}
                                        onSubmit={async (values, { setSubmitting }) => {
                                            try {
                                                const payload = {
                                                    reRentingStatus: this.state.lostOrHold, // LOST / HOLD / RERENTED_NOT_MERGED
                                                    reRentingRemarksCategory:
                                                        this.state.lostOrHold === "LOST"
                                                            ? values.reRentingRemarksCategory
                                                            : undefined,
                                                    reRentingRemarks: values.reRentingRemarks
                                                };

                                                const result = await RerentingTrackerServices.markRerentingStatus(
                                                    this.state.selectedLease?.id,
                                                    payload
                                                );

                                                if (result && (result.status === 200 || result.status === 201)) {
                                                    store.addNotification({
                                                        title: "Success!",
                                                        message: `Lease marked as ${this.state.lostOrHold} successfully!`,
                                                        type: "success",
                                                        insert: "top",
                                                        container: "top-right",
                                                        animationIn: ["animated", "fadeIn"],
                                                        animationOut: ["animated", "fadeOut"],
                                                        dismiss: { duration: 5000, onScreen: true }
                                                    });

                                                    this.setState({ showLostModal: false });
                                                    await this.getLeasesList();
                                                }
                                            } finally {
                                                setSubmitting(false);
                                            }
                                        }}
                                    >
                                        {({
                                            values,
                                            errors,
                                            touched,
                                            handleChange,
                                            handleBlur,
                                            handleSubmit,
                                            isSubmitting
                                        }) => (
                                            <Form onSubmit={handleSubmit}>
                                                {this.state.lostOrHold === "LOST" && (
                                                    <Form.Group controlId="reRentingRemarksCategory">
                                                        <Form.Label>Remarks Category</Form.Label>
                                                        <Form.Control
                                                            as="select"
                                                            name="reRentingRemarksCategory"
                                                            value={values.reRentingRemarksCategory}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            isInvalid={
                                                                touched.reRentingRemarksCategory &&
                                                                !!errors.reRentingRemarksCategory
                                                            }
                                                        >
                                                            <option value="">Select Category</option>
                                                            <option value="Self use by owner">Self use by owner</option>
                                                            <option value="Property Sold Out">Property Sold Out</option>
                                                            <option value="Owner No Longer Wants Services">Owner No Longer Wants Services</option>
                                                            <option value="Finalized with Other Tenant/Broker">Finalized with Other Tenant/Broker</option>
                                                            <option value="Others">Others</option>
                                                        </Form.Control>
                                                        {errors.reRentingRemarksCategory &&
                                                            touched.reRentingRemarksCategory && (
                                                                <Form.Text className="text-danger">
                                                                    {errors.reRentingRemarksCategory}
                                                                </Form.Text>
                                                            )}
                                                    </Form.Group>
                                                )}

                                                {/* Remarks (always required) */}
                                                <Form.Group controlId="reRentingRemarks" className="mt-3">
                                                    <Form.Label>Remarks</Form.Label>
                                                    <Form.Control
                                                        as="textarea"
                                                        rows={3}
                                                        name="reRentingRemarks"
                                                        placeholder="Please provide remarks"
                                                        value={values.reRentingRemarks}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        isInvalid={
                                                            touched.reRentingRemarks && !!errors.reRentingRemarks
                                                        }
                                                    />
                                                    {errors.reRentingRemarks && touched.reRentingRemarks && (
                                                        <Form.Text className="text-danger">
                                                            {errors.reRentingRemarks}
                                                        </Form.Text>
                                                    )}
                                                </Form.Group>

                                                <Modal.Footer>
                                                    <Button
                                                        variant="secondary"
                                                        onClick={() => this.setState({ showLostModal: false })}
                                                        disabled={isSubmitting}
                                                    >
                                                        Cancel
                                                    </Button>

                                                    <Button
                                                        type="submit"
                                                        variant={
                                                            this.state.lostOrHold === "LOST"
                                                                ? "danger"
                                                                : this.state.lostOrHold === "HOLD"
                                                                    ? "warning"
                                                                    : "primary"
                                                        }
                                                        disabled={isSubmitting}
                                                    >
                                                        {isSubmitting ? "Submitting..." : "Submit"}
                                                    </Button>
                                                </Modal.Footer>
                                            </Form>
                                        )}
                                    </Formik>
                                </Modal.Body>
                            </Modal>

                            <Modal
                                backdrop="static"
                                keyboard={false}
                                key={'m' + 20}
                                show={this.state.showRerentedModal}
                                onHide={() => this.setState({ showRerentedModal: false })}
                                centered
                            >
                                <Modal.Header closeButton>
                                    <Modal.Title>Merge Duplicate Property</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <Formik
                                        initialValues={{
                                            leaseId: this.state.selectedLease?.id,
                                            originalHouseId: "",
                                            duplicateHouseId: ""
                                        }}
                                        validationSchema={Yup.object().shape({
                                            leaseId: Yup.number().required("Original HouseId is required"),
                                            originalHouseId: Yup.number().required("Original HouseId is required"),
                                            duplicateHouseId: Yup.number()
                                                .required("Duplicate HouseId is required")
                                                .notOneOf([Yup.ref("originalHouseId")], "Duplicate cannot be same as Original")
                                        })}
                                        onSubmit={async (values) => {
                                            const result = await RerentingTrackerServices.markPropertyRerented(values);

                                            if (result && result.status === 201) {
                                                store.addNotification({
                                                    title: "Success!",
                                                    message: `Properties merged successfully!`,
                                                    type: "success",
                                                    insert: "top",
                                                    container: "top-right",
                                                    animationIn: ["animated", "fadeIn"],
                                                    animationOut: ["animated", "fadeOut"],
                                                    dismiss: {
                                                        duration: 5000,
                                                        onScreen: true,
                                                        showIcon: true,
                                                        pauseOnHover: true
                                                    }
                                                });
                                                this.setState({ showRerentedModal: false });
                                                await this.getLeasesList(); // or refresh list
                                            }
                                            this.setState({ showRerentedModal: false });
                                        }}
                                    >
                                        {({ values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting }) => (
                                            <Form onSubmit={handleSubmit}>
                                                <Row>
                                                    <Col>
                                                        <Form.Group controlId="originalHouseId">
                                                            <Form.Label>Original HouseId</Form.Label>
                                                            <Form.Control
                                                                type="number"
                                                                name="originalHouseId"
                                                                value={values.originalHouseId}
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                            />
                                                            {errors.originalHouseId && touched.originalHouseId && (
                                                                <Form.Text className="text-danger">{errors.originalHouseId}</Form.Text>
                                                            )}
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col>
                                                        <Form.Group controlId="duplicateHouseId">
                                                            <Form.Label>Duplicate HouseId</Form.Label>
                                                            <Form.Control
                                                                type="number"
                                                                name="duplicateHouseId"
                                                                value={values.duplicateHouseId}
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                            />
                                                            {errors.duplicateHouseId && touched.duplicateHouseId && (
                                                                <Form.Text className="text-danger">{errors.duplicateHouseId}</Form.Text>
                                                            )}
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col xs={12} className="text-right">
                                                        <Button variant="secondary" className="mr-2" onClick={() => this.setState({ showRerentedModal: false })}>
                                                            Cancel
                                                        </Button>
                                                        <Button type="submit" variant="primary" disabled={isSubmitting}>
                                                            {isSubmitting ? "Saving..." : "Save & Merge"}
                                                        </Button>
                                                    </Col>
                                                </Row>
                                            </Form>
                                        )}
                                    </Formik>
                                </Modal.Body>
                            </Modal>

                            <Modal
                                backdrop="static"
                                keyboard={false}
                                show={this.state.showAddBeatsModal}
                                onHide={() => this.setState({ showAddBeatsModal: false })}
                                centered
                            >
                                <Modal.Header closeButton>
                                    <Modal.Title>Add Beats New Listing ID</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <Formik
                                        initialValues={{
                                            newbeatsListingIdentifier: "",
                                        }}
                                        validationSchema={Yup.object().shape({
                                            newbeatsListingIdentifier: Yup.string().required("Beats New Listing ID is required"),
                                        })}
                                        onSubmit={async (values, { setSubmitting }) => {
                                            try {
                                                const result = await RerentingTrackerServices.updateBeatsListingId(this.state.selectedLease?.houseOffering.id, values);

                                                if (result && result.status === 200) {
                                                    store.addNotification({
                                                        title: "Success!",
                                                        message: `Beats New Listing ID added successfully!`,
                                                        type: "success",
                                                        insert: "top",
                                                        container: "top-right",
                                                        animationIn: ["animated", "fadeIn"],
                                                        animationOut: ["animated", "fadeOut"],
                                                        dismiss: {
                                                            duration: 5000,
                                                            onScreen: true,
                                                            showIcon: true,
                                                            pauseOnHover: true,
                                                        },
                                                    });
                                                    this.setState({ showAddBeatsModal: false, newBeatsListingId: "" });
                                                    await this.getLeasesList(); // refresh list
                                                }
                                            } catch (err) {
                                                console.error(err);
                                            } finally {
                                                setSubmitting(false);
                                            }
                                        }}
                                    >
                                        {({ values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting }) => (
                                            <Form onSubmit={handleSubmit}>
                                                <Row>
                                                    <Col>
                                                        <Form.Group controlId="newbeatsListingIdentifier">
                                                            <Form.Label>Beats New Listing ID<span className="text-danger">*</span></Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                name="newbeatsListingIdentifier"
                                                                value={values.newbeatsListingIdentifier}
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                                placeholder="Enter Beats New Listing ID"
                                                            />
                                                            {errors.newbeatsListingIdentifier && touched.newbeatsListingIdentifier && (
                                                                <Form.Text className="text-danger">{errors.newbeatsListingIdentifier}</Form.Text>
                                                            )}
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col xs={12} className="text-right">
                                                        <Button
                                                            variant="secondary"
                                                            className="mr-2"
                                                            onClick={() => this.setState({ showAddBeatsModal: false })}
                                                        >
                                                            Cancel
                                                        </Button>
                                                        <Button type="submit" variant="primary" disabled={isSubmitting}>
                                                            {isSubmitting ? "Saving..." : "Save"}
                                                        </Button>
                                                    </Col>
                                                </Row>
                                            </Form>
                                        )}
                                    </Formik>
                                </Modal.Body>
                            </Modal>

                            <Modal
                                show={this.state.showViewReasonModal}
                                onHide={() => this.setState({ showViewReasonModal: false })}
                                centered
                            >
                                <Modal.Header closeButton>
                                    <Modal.Title>
                                        {this.state.lostOrHold === "LOST" ? "Lost Reason Details" : "Hold Reason Details"}
                                    </Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    {this.state.selectedLease && (
                                        <div>
                                            <p>
                                                <strong>Status:</strong> {this.state.selectedLease.reRentingStatus}
                                            </p>

                                            {/* Show Remarks Category only for LOST */}
                                            {this.state.lostOrHold === "LOST" && (
                                                <p>
                                                    <strong>Remarks Category:</strong>{" "}
                                                    {this.state.selectedLease.reRentingRemarksCategory || "Not Available"}
                                                </p>
                                            )}

                                            <p>
                                                <strong>Remarks:</strong>{" "}
                                                {this.state.selectedLease.reRentingRemarks || "Not Available"}
                                            </p>

                                            <p>
                                                <strong>Status Marked At:</strong>{" "}
                                                {this.state.selectedLease.reRentingStatusMarkedAt
                                                    ? formatDateTime(this.state.selectedLease.reRentingStatusMarkedAt)
                                                    : "Not Available"}
                                            </p>

                                            <p>
                                                <strong>Marked By:</strong>{" "}
                                                {this.state.selectedLease.reRentingStatusMarker?.fullName || "Not Available"}
                                            </p>
                                        </div>
                                    )}
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button
                                        variant="secondary"
                                        onClick={() => this.setState({ showViewReasonModal: false })}
                                    >
                                        Close
                                    </Button>
                                </Modal.Footer>
                            </Modal>

                            <Modal
                                show={this.state.showConfirmModal}
                                onHide={() => this.setState({ showConfirmModal: false })}
                                centered
                            >
                                <Modal.Header closeButton>
                                    <Modal.Title>Confirm Action</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    <p>{this.state.confirmMessage}</p>
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button
                                        variant="secondary"
                                        onClick={() => this.setState({ showConfirmModal: false })}
                                    >
                                        Cancel
                                    </Button>

                                    <Button
                                        variant="primary"
                                        onClick={async () => {
                                            await this.state.confirmAction();   // Run the stored function
                                            this.setState({ showConfirmModal: false });
                                            this.getLeasesList();
                                        }}
                                    >
                                        Yes, Continue
                                    </Button>
                                </Modal.Footer>
                            </Modal>



                            {/* Code for pagination */}
                            {showPagination && showPagination && <UltimatePagination
                                currentPage={page}
                                totalPages={total}
                                onChange={this.onPageChange}
                                boundaryPagesRange={0}
                                hidePreviousAndNextPageLinks={true}
                                hideFirstAndLastPageLinks={page !== 1 && page !== total ? false : true}
                            />}
                        </PortletBody>
                    </Portlet>
                </Container >
            </>
        )
    }
}

const mapStateToProps = state => ({
    serviceRequestCategories: state.auth && state.auth.staticData && state.auth.staticData.serviceRequests.categories,
    userDetails: state.auth && state.auth.user
});

export default
    connect(
        mapStateToProps,
        null
    )(ReRentingTracker);